





















































































import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import generalFeedback from '@/store/modules/generalfeedback';
import UserFeedback from '@/components/UserFeedback';
import surveys from '@/store/modules/surveys';
import UserFeedbackPrompt from '@/components/UserFeedbackPrompt.vue';

@Component({
  components: {
    UserFeedback,
    UserFeedbackPrompt,
  },
})
export default class Footer extends Vue {
  @Prop() private newui?: object;
  @Prop({ default: false }) private newuistatus?: boolean;
  @Prop({ default: false }) private newuimodel?: boolean;
  private valid: boolean = false;
  private userFeedbackDialog = false;
  private submitFeedbackDialog = false;
  private submitFeedbackSuccess = false;
  private submitFeedbackData: any = {
    name: '',
    email: '',
    category: 'sustainability',
    message: '',
    user_id: '',
  };
  private showUserFbBtn: boolean = false;

  // private form: any = null;

  private submitFeedback(feedback: any) {
    const submitData = {
      service: 'EconomX',
      feedback,
    };
    generalFeedback.submitGeneralFeedback(submitData).then((response: any) => {
      if (response.status === 200) {
        this.$swal('Thanks!', 'Thank you for your Feedback!', 'success');
        this.submitFeedbackDialog = false;
      }
    });
  }

  private submitFb() {
    if ((this.$refs.submitFbForm as any).validate()) {
      if (this.valid) {
        this.submitFeedback(this.submitFeedbackData);
      }
    }
  }

  private cancelSubmitFeedback() {
    this.submitFeedbackDialog = !this.submitFeedbackDialog;
    (this.$refs.submitFbForm as any).reset();
    (this.$refs.submitFbForm as any).resetValidation();
  }

  private toggleNewUI() {
    this.newuimodel = !this.newuimodel;
    this.$store.state.newui.enabled = this.newuimodel;
  }

  get form() {
    return surveys.surveyJson;
  }

  get lastSurvey() {
    return this.$store.getters.currentUser && this.$store.getters.currentUser.last_survey;
  }

  get lastSurveyDelayed() {
    return (
      this.$store.getters.currentUser &&
      this.$store.getters.currentUser.last_survey &&
      this.$store.getters.currentUser.last_survey.status === 'delayed'
    );
  }

  private created() {
    if (this.$store.getters.currentUser) {
      this.submitFeedbackData.user_id = this.$store.getters.currentUser.id;
      surveys.userSurveyJson();
      if (this.lastSurvey && this.lastSurveyDelayed) {
        this.showUserFbBtn = true;
      }
    }

    this.$events.on('userLoggedIn', () => {
      if (this.$store.getters.currentUser) {
        this.submitFeedbackData.user_id = this.$store.getters.currentUser.id;
        surveys.userSurveyJson();
        if (this.lastSurvey && this.lastSurveyDelayed) {
          this.showUserFbBtn = true;
        }
      }
    });

    this.$events.on('fb-prompt-action', (data: any) => {
      if (data.action === 'show') {
        this.showUserFbBtn = true;
        this.userFeedbackDialog = true;
      } else if (data.action === 'delayed') {
        this.showUserFbBtn = true;
      }
    });

    this.$events.on('close-user-feedback', () => {
      this.userFeedbackDialog = false;
      this.showUserFbBtn = false;
    });
  }
}
